import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsPdf = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M16.5603638,0.875H4.4068723v12.0390921H2.789546v6.3414412l1.6173263,1.6128387V23.125H21.210453V5.5273342
		L16.5603638,0.875z M16.9058113,2.552892l2.6245098,2.6245072h-2.6245098
		C16.9058113,5.1773992,16.9058113,2.5528905,16.9058113,2.552892z M3.4849286,18.5601501v-4.950676h15.3634701v4.950676H3.4849286z
		 M20.5173168,22.43186H5.1022549v-3.1763268h14.4415264v-6.3414412H5.1022549V1.5703826h11.1104183v4.3046432h4.3046436V22.43186z"
        />
        <path
          d="M9.6581335,14.5942259c-0.2714243-0.1951561-0.6034136-0.2826385-0.9331598-0.246748H7.1726999v3.4275618
		h0.6505194V16.666914h0.9129705c0.3275032,0.0381336,0.6594925-0.0403767,0.9331589-0.2265587
		c0.188426-0.2646942,0.2691803-0.5899544,0.2310467-0.9129715C9.938529,15.1976376,9.8532877,14.8634062,9.6581335,14.5942259z
		 M9.240901,15.5341139c0,0.2534771-0.0403767,0.4149857-0.12113,0.4822817h0.004487
		c-0.1727247,0.0874844-0.3678808,0.123373-0.5585499,0.1009426H7.8209753v-1.2247705h0.8052988
		c0.1794529-0.0246744,0.3589067,0.0112162,0.5159283,0.1031847C9.2296858,15.1595039,9.2655773,15.3479309,9.240901,15.5341139z"
        />
        <path
          d="M13.002697,14.6660061c-0.2781534-0.2422619-0.6415462-0.3566637-1.00494-0.3185301v0.0000019h-1.6823769
		v3.4275618h1.7025661c0.5406036,0,0.8860521-0.12113,1.0408297-0.3633938
		c0.2018852-0.5249023,0.2803965-1.0879364,0.2310467-1.6464863C13.3279572,15.3770914,13.2270136,14.9867792,13.002697,14.6660061z
		 M12.4934988,17.0101185v0.0000019c-0.0942135,0.1435623-0.2938566,0.2153435-0.6034136,0.2153435h-0.9264288v-2.3306541h0.9645634
		c0.3028278,0,0.4957409,0.0695381,0.5764952,0.2041283c0.1099157,0.309557,0.1502924,0.6370611,0.123374,0.9623203
		C12.6572495,16.3842754,12.6101437,16.7095356,12.4934988,17.0101185z"
        />
        <polygon
          points="13.7631321,17.7705517 13.7631321,17.7705536 14.4136515,17.7705536 14.4136515,16.3640862 
		15.9524651,16.3640862 15.9524651,15.8167524 14.4136515,15.8167524 14.4136515,14.8948097 16.0309753,14.8948097 
		16.0309753,14.347476 13.7631321,14.347476 	"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsPdf;
